export enum ClientOnboardingPermissions {
  VIEW_CLIENT_ONBOARDING = "view_client_onboarding",
  CREATE_CLIENT_ONBOARDING = "create_client_onboarding",
  UPDATE_CLIENT_ONBOARDING = "update_client_onboarding",
  APPROVE_REJECT_CLIENT_ONBOARDING = "approve_reject_client_onboarding",
}

export const ClientOnboardingPermissionsText: Record<
  ClientOnboardingPermissions,
  string
> = {
  [ClientOnboardingPermissions.VIEW_CLIENT_ONBOARDING]:
    "View Client Onboarding",
  [ClientOnboardingPermissions.CREATE_CLIENT_ONBOARDING]:
    "Create Client Onboarding",
  [ClientOnboardingPermissions.UPDATE_CLIENT_ONBOARDING]:
    "Update Client Onboarding",
  [ClientOnboardingPermissions.APPROVE_REJECT_CLIENT_ONBOARDING]:
    "Approve/Reject Client Onboarding",
};
